// extracted by mini-css-extract-plugin
export default {"placeholderAnimate":"bHQZ660EdpZHJnpMfcs_"};